import { useState } from "react";
import "./billpayment.scss";
// import { dataBillPayment } from "../../data/dataBillPayment";
import HeroImage from "../../components/HeroImage/HeroImage";
import Features from "../../components/Features/Features";
import Registers from "../../components/Registers/Registers";
import IconsBillPayment from "../../components/IconsBillPayment/IconsBillPayment";
import GoToTop from "../../helpers/GoToTop";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import Loading from "../../helpers/Loading";
import Seo from "../../helpers/Seo";

function BillPayment() {
  const [active, setActive] = useState(0);
  const [index, setIndex] = useState(0);
  // Handle Tabs Sekunder
  const handleTab = (idx) => {
    setIndex(idx);
    setActive(idx);
  };

  // GET API WITH CUSTOM HOOKS
  const { response, loading } = useFetch("/api/services/bill-payment");
  // console.log("response :>> ", response);

  // SET REDUX
  const state = useSelector((state) => state.translateReducer.bahasa);
  // SETUP CONTENTS BASED ON LANGUAGE
  let content = {
    English: {
      data: response?.English,
    },
    Indonesia: {
      data: response?.Indonesia,
    },
  };

  if (state === "Indonesia") {
    content = content.Indonesia;
  } else {
    content = content.English;
  }

  // Loading sebelum data dari API masuk
  if (!response && loading) {
    return <Loading />;
  }

  return (
    <div className="billpayment">
      <Seo
        title="Layanan Bayar Tagihan | Allobank"
        description="Bayar tagihan bulanan lebih mudah. Untuk hidup kamu lebih simple."
      />
      <GoToTop />
      <HeroImage source={content.data} />
      {/* Icons Bill Payments */}
      <IconsBillPayment
        data={content.data?.typeService}
        title={content.data?.titleTypeService}
      />
      {/* Features */}
      <Features dataFeatures={content.data} />
      {/* Registers */}
      <Registers
        dataRegisters={content.data}
        activeSekunder={active}
        handleTabSekunder={handleTab}
        indexSekunder={index}
      />
    </div>
  );
}

export default BillPayment;
